import { Component, Input, OnInit } from '@angular/core';
import { ActivityCard } from '../../core/domain/activity-card';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-activity-card',
  templateUrl: './activity-card.component.html',
  styleUrls: ['./activity-card.component.css'],
  imports: [NgClass],
})
export class ActivityCardComponent implements OnInit {
  @Input() activityCard?: ActivityCard;

  constructor() {}

  ngOnInit(): void {}
}
